import React from "react";
import DataVisualization from "../";
import {Col, Row} from "reactstrap";


const Section = ({data: jsonData}) => {
    const {child} = jsonData;
    const numberOfColumn = Math.ceil(12 / child.length);
    return (
        <>
            <Row>
                {
                    child.map((chi, key) =>
                        <Col lg={numberOfColumn} key={key}>
                            <DataVisualization data={chi}/>
                        </Col>
                    )
                }
            </Row>
        </>
    );
};

export default Section;